<template>
  <div id="modalLinePEAKConnect">
    <ModalBox :showModal.sync="showModal">
      <template slot="header">
        <h2>{{ $t("ModalLinePeakConnect.Header_Title") }}</h2>
      </template>
      <template slot="body">
        <div v-if="activePageIndex === 0" class="page-canvas" id="page1">
          <div class="row px-3">
            <div class="col mb-0 left-panel">
              <h2>
                {{ $t("ModalLinePeakConnect.Page_1.Header_1") }}<br /><span class="green-text">{{
                  $t("ModalLinePeakConnect.Page_1.Header_2_LINE_GreenText")
                }}</span>
                {{ $t("ModalLinePeakConnect.Page_1.Header_3") }}
              </h2>
              <div class="image-container">
                <img
                  :src="
                    peakFileServer.UrlCombine(
                      'peakengine/Content/Image/ApplicationStore/LinePEAKConnectImg_QR_Page1.png'
                    )
                  "
                  alt="Line PEAK Connect - scannable Line QR code"
                />
              </div>
              <div v-for="(text, index) in $t('ModalLinePeakConnect.Page_1.Paragraph_List')" :key="index">
                <div class="list-item">
                  <i class="fas fa-check-circle"></i>
                  <p>{{ text }}</p>
                </div>
              </div>
            </div>
            <div class="col-auto mb-0 right-panel">
              <img
                :src="
                  peakFileServer.UrlCombine(
                    'peakengine/Content/Image/ApplicationStore/LinePEAKConnectImg_iPhone_Page1.png'
                  )
                "
                alt="Line PEAK Connect - PEAK Connect in Line mobile application"
              />
            </div>
          </div>
        </div>

        <div v-else-if="activePageIndex === 1" class="page-canvas" id="page2">
          <div class="row px-3">
            <div class="col-12 mb-0 panel">
              <h2>{{ $t("ModalLinePeakConnect.Page_2.Header_1") }}</h2>
              <img
                :src="
                  peakFileServer.UrlCombine(
                    'peakengine/Content/Image/ApplicationStore/LinePEAKConnectImg_ProfitsGraphic_Page2.png'
                  )
                "
                alt="Line PEAK Connect - real time profits graphic info"
              />
              <p>
                {{ $t("ModalLinePeakConnect.Page_2.Paragraph_1") }}<br />{{
                  $t("ModalLinePeakConnect.Page_2.Paragraph_2")
                }}
              </p>
            </div>
          </div>
        </div>

        <div v-else-if="activePageIndex === 2" class="page-canvas" id="page3">
          <div class="row px-3">
            <div class="col-12 mb-0 panel">
              <h2>
                {{ $t("ModalLinePeakConnect.Page_3.Header_1") }}<br />{{ $t("ModalLinePeakConnect.Page_3.Header_2") }}
              </h2>
              <img
                :src="
                  peakFileServer.UrlCombine(
                    'peakengine/Content/Image/ApplicationStore/LinePEAKConnectImg_FileVault_Page3.png'
                  )
                "
                alt="Line PEAK Connect - file vault connected"
              />
              <p>
                {{ $t("ModalLinePeakConnect.Page_3.Paragraph_1") }}
                <span class="hyper-link" @click="LinkToFileVault()">{{
                  $t("ModalLinePeakConnect.Page_3.HyperLink")
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div v-else-if="activePageIndex === 3" class="page-canvas" id="page4">
          <div class="row px-3">
            <div class="col-12 mb-0 panel">
              <h2>{{ $t("ModalLinePeakConnect.Page_4.Header_1") }}</h2>
              <img
                :src="
                  peakFileServer.UrlCombine(
                    'peakengine/Content/Image/ApplicationStore/LinePEAKConnectImg_CreateDoc_Page4.png'
                  )
                "
                alt="Line PEAK Connect - create document from PEAK Connect"
              />
              <p>
                {{ $t("ModalLinePeakConnect.Page_4.Paragraph_1") }}<br />{{
                  $t("ModalLinePeakConnect.Page_4.Paragraph_2")
                }}<br />{{ $t("ModalLinePeakConnect.Page_4.Paragraph_3") }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="row footer">
          <div class="col-5 back-button">
            <div v-if="canGoBack" @click="Back()">
              <i class="fas fa-angle-left"></i>
              <span>{{ $t("ModalLinePeakConnect.Back_Button") }}</span>
            </div>
          </div>
          <div class="col-2 page-number">
            <p>{{ `${activePageIndex + 1}/4` }}</p>
          </div>
          <div class="col-5 next-button">
            <div v-if="canGoNext" @click="Next()">
              <span>{{ $t("ModalLinePeakConnect.Next_Button") }}</span>
              <i class="fas fa-angle-right"></i>
            </div>
            <buttonStyle
              v-else
              width="150px"
              theme="white"
              styleButton="primary"
              :text="$t('Btn_Close')"
              @click="HideModal()"
            />
          </div>
        </div>
      </template>
    </ModalBox>
  </div>
</template>

<script lang="ts">
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class ModalLinePEAKConnect extends Vue {
  private showModal = true;
  private peakFileServer = process.env.VUE_APP_PeakFileServer?.toString() ?? "";
  private activePageIndex = 0;

  @Watch("showModal")
  showModalChanged(newVal: boolean) {
    if (!newVal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }

  get canGoBack() {
    return this.activePageIndex !== 0;
  }

  get canGoNext() {
    return this.activePageIndex < 3;
  }

  public Back() {
    this.activePageIndex--;
  }

  public Next() {
    this.activePageIndex++;
  }

  public LinkToFileVault() {
    window.open(`${process.env.VUE_APP_PeakAccount}document/uploadDocument?emi=${MerchantId().PeakEncryption()}`);
  }
}
</script>

<style lang="scss" scoped>
#modalLinePEAKConnect {
  .page-canvas {
    min-height: 400px;
    display: flex;
    justify-content: center;
    padding: 0px 32px;
    padding-top: 8px;
  }

  #page1 {
    .left-panel {
      padding-right: 24px;

      h2 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 24px;

        .green-text {
          color: $green;
        }
      }

      .image-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 24px;

        img {
          width: 140px;
        }
      }

      .list-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 4px;

        i {
          font-size: 14px;
          color: $blue_default;
          margin-top: 4px;
        }

        p {
          font-size: 16px;
        }
      }
    }

    .right-panel {
      img {
        width: 180px;
      }
    }
  }

  #page2 {
    .panel {
      display: flex;
      flex-direction: column;
      align-items: center;

      h2 {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 24px;
      }

      img {
        width: 460px;
        margin-bottom: 24px;
      }

      p {
        font-size: 16px;
        text-align: center;
      }
    }
  }

  #page3 {
    .panel {
      display: flex;
      flex-direction: column;
      align-items: center;

      h2 {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 24px;
      }

      img {
        width: 500px;
        margin-bottom: 24px;
      }

      p {
        font-size: 16px;
        text-align: center;
      }

      .hyper-link {
        font-size: 16px;
        color: $blue_default;
        cursor: pointer;
        transition: 0.25s;

        &:hover {
          color: $blue_hover;
        }

        &:active {
          color: $blue_active;
        }
      }
    }
  }

  #page4 {
    .panel {
      display: flex;
      flex-direction: column;
      align-items: center;

      h2 {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 24px;
      }

      img {
        width: 440px;
        margin-bottom: 24px;
      }

      p {
        font-size: 16px;
        text-align: center;
      }
    }
  }

  .footer {
    width: 100%;
    height: 28px;
    padding: 0;
    margin: 0 !important;

    .back-button {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin: 0;

      div {
        font-size: 16px;
        color: $blue_default;
        gap: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        transition: 0.25s;

        i {
          margin-bottom: 2px;
        }
      }

      div:hover {
        color: $blue_hover;
      }

      div:active {
        color: $blue_active;
      }
    }

    .page-number {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin: 0;

      p {
        font-size: 16px;
        color: $label;
      }
    }

    .next-button {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      margin: 0;
      gap: 4px;
      margin: -6px 0px;

      div {
        font-size: 16px;
        color: $blue_default;
        gap: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        transition: 0.25s;

        i {
          margin-bottom: 2px;
        }
      }

      div:hover {
        color: $blue_hover;
      }

      div:active {
        color: $blue_active;
      }
    }
  }
}
</style>
